<script>
    import { createEventDispatcher, getContext } from 'svelte';
    const dispatch = createEventDispatcher();

    const printStore = getContext('printStore');

    $: printing = $printStore;

    export let title;

    export let editing;
</script>

<style>
    .report-subject-title {
        font-size: 36px;
        margin-top: 0;
        font-weight: bolder;
        margin-bottom: 10px;
    }

    .report-subject-title:focus {
        outline: none;
        box-shadow: 0 0 3px 1px #2c9abb;
        border-color: transparent;
    }

    input.report-subject-title {
        background-color: #F5F5F5;
        border-radius: 8px;
        border: 1px solid #b5b5b5;
        width: 100%;
        display: block;
        padding-left: 10px;
    }
</style>

{#if editing && !printing}
    <input type="text" bind:value={title} maxlength="100" on:change class="report-subject-title">
{:else}
    <h2 class="report-subject-title">{title}</h2>
{/if}




